<template>
  <DataListStateful
    title="Области"
    resource="districts"
    store="districts"
    :columns="columns"
    :filter-options="filter"
  />
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: "Ид", name: "id", dataPath: "Id", sortable: false },
        {
          title: "Наименование",
          name: "title",
          dataPath: "Title",
          sortable: true,
        },
        {
          title: "Страна",
          name: "country",
          dataPath: "Country.Title",
          sortable: true,
        },
        {
          title: "Регион",
          name: "region",
          dataPath: "Region.Title",
          sortable: true,
        },
      ],
      filter: {
        title: {
          title: "Наименование",
          type: "text",
        },
        country: {
          title: "Страна",
          type: "reference",
          resource: "countries",
        },
        region: {
          title: "Регион",
          type: "reference",
          resource: "regions",
        },
      },
    };
  },
};
</script>
